// extracted by mini-css-extract-plugin
export default {"therapiesSelect":"TherapistStep4_2_therapiesSelect__ws+V0","modalitiesSelect":"TherapistStep4_2_modalitiesSelect__JU1Lu"};